import { Language, PageView } from '../types';
import { TRANSLATIONS } from '../translations';
import { Users, BookOpen, Sparkles } from 'lucide-react';

interface FooterProps {
    language: Language;
    setPageView: (view: PageView) => void;
}

export default function Footer({ language, setPageView }: FooterProps) {
    const t = TRANSLATIONS[language];

    const handleNavigation = (view: PageView) => {
        setPageView(view);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <footer className="footer mt-auto">
            <div className="max-w-5xl mx-auto">
                {/* Content Pages - Featured Links */}
                <div className="flex flex-wrap items-center justify-center gap-3 mb-4">
                    <a
                        href="/characters"
                        onClick={(e) => { e.preventDefault(); handleNavigation('characters'); }}
                        className="flex items-center gap-2 px-3 py-1.5 bg-stone-800/50 hover:bg-stone-800 border border-stone-700 hover:border-[#4a7c59]/50 rounded-lg transition-all text-stone-300 hover:text-white text-sm no-underline"
                    >
                        <Users size={14} className="text-[#6b9b7a]" />
                        <span className="font-medium">{t.nav_characters || 'Characters'}</span>
                    </a>
                    <a
                        href="/guide"
                        onClick={(e) => { e.preventDefault(); handleNavigation('guide'); }}
                        className="flex items-center gap-2 px-3 py-1.5 bg-stone-800/50 hover:bg-stone-800 border border-stone-700 hover:border-[#4a7c59]/50 rounded-lg transition-all text-stone-300 hover:text-white text-sm no-underline"
                    >
                        <BookOpen size={14} className="text-[#6b9b7a]" />
                        <span className="font-medium">{t.nav_guide || 'How to Play'}</span>
                    </a>
                    <a
                        href="/trivia"
                        onClick={(e) => { e.preventDefault(); handleNavigation('trivia'); }}
                        className="flex items-center gap-2 px-3 py-1.5 bg-stone-800/50 hover:bg-stone-800 border border-stone-700 hover:border-[#4a7c59]/50 rounded-lg transition-all text-stone-300 hover:text-white text-sm no-underline"
                    >
                        <Sparkles size={14} className="text-[#6b9b7a]" />
                        <span className="font-medium">{t.nav_trivia || 'Trivia'}</span>
                    </a>
                </div>

                {/* Legal Links */}
                <div className="flex flex-wrap items-center justify-center gap-4 text-xs mb-3">
                    <a
                        href="/privacy"
                        onClick={(e) => { e.preventDefault(); handleNavigation('privacy'); }}
                        className="text-[#6b9b7a] hover:text-[#8bbb9a] transition-colors no-underline"
                    >
                        {t.footer_privacy}
                    </a>
                    <span className="text-stone-600">•</span>
                    <a
                        href="/about"
                        onClick={(e) => { e.preventDefault(); handleNavigation('about'); }}
                        className="text-[#6b9b7a] hover:text-[#8bbb9a] transition-colors no-underline"
                    >
                        {t.footer_about}
                    </a>
                    <span className="text-stone-600">•</span>
                    <a
                        href="/contact"
                        onClick={(e) => { e.preventDefault(); handleNavigation('contact'); }}
                        className="text-[#6b9b7a] hover:text-[#8bbb9a] transition-colors no-underline"
                    >
                        {t.footer_contact}
                    </a>
                </div>

                {/* Copyright */}
                <p className="text-[10px] text-stone-600">
                    {t.footer_copyright.replace('{year}', new Date().getFullYear().toString())}
                </p>
            </div>
        </footer>
    );
}
